module.exports = __webpack_public_path__ + "img/t4-m2.3f253a46.png";